//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        search: {
            type: Object,
            default: () => ({
                rowguid: ''
            })
        }
    },
    data () {
        return {
            form: {
            }
        }
    },
    methods: {
        submitHandler() {
            this.cancleHandler();
        },
        cancleHandler() {
            this.$emit('close');
        },
        timeChange(e) {
            this.form.starttime = e ? e[0] : '';
            this.form.endtime = e ? e[1] : '';
        },
        afterDetail(data) {
            data.time = [data.starttime, data.endtime];
        },

        getData() {
            this.$post(this.getStore('finUrl') + '/verify/bill_detail', this.search, (data) => {
                data.bill_detail.order_list = data.order_list;
                this.form = data.bill_detail;
            });
        },
        passHandler(type) {
            if(type === '2') {
                var that = this;
                this.$prompt('请输入异议内容', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '请填写异议内容'
                }).then(({ value }) => {
                    cb.call(this, value);
                }).catch(() => {
                    return false;
                });
            } else {
                cb.call(this, '');
            };

            function cb(detail) {
                this.$post(this.getStore('finUrl') + '/verify/confirm_bill', {
                    shbj: type,
                    detail: detail,
                    rowguid: this.search.rowguid
                }, (data, res) => {
                    ShowMsg.call(this, res.msg, 'success');
                    this.$emit('close');
                });
            }
        }
    },
    mounted () {
        this.getData();
    }
}
